// Shared timestamp formatting for the /distribution editors (audit log rows,
// trading-note freshness lines).

// Rows under a minute old render "just now", under an hour "Nm ago", under
// a day "Nh ago". Older rows show the local date+time. The UTC ISO string
// goes into the title attribute so hovering shows the canonical timestamp.
export function formatRelative(ts: string, now: number = Date.now()): string {
  const t = new Date(ts).getTime()
  const diff = now - t
  if (diff < 60_000) return 'just now'
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m ago`
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)}h ago`
  return new Date(ts).toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatTsUtc(ts: string): string {
  return new Date(ts).toISOString().replace('T', ' ').slice(0, 19).concat(' UTC')
}
